import React, { Fragment, useState } from 'react'
import { Table } from 'react-bootstrap'
import PropTypes from 'prop-types'
import RemoveCourseModal from './RemoveCourseModal'
import { useStateValue } from '../../state'

const ContextCoursesTable = ({context}) => {
  const [removeCourseModalOpen, toggleModal] = useState(false)
  const [contextCourseModalObject, setContextCourseModalObject] = useState({
    title: '',
    coursenum: '',
  })
  const [, dispatch] = useStateValue()

  const openModal = ccc => {
    setContextCourseModalObject(ccc)
    toggleModal(true)
  }

  const showAssessmentTool = async (coursenum, toolName) => {
    dispatch({
      type: 'showContextTools',
      showContextTools: toolName,
      contextToolsCoursenum: coursenum,
    })
  }

  return (
    <Fragment>
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            <th>Created</th>
            <th>Coursenum</th>
            <th>Course Title</th>
            <th>Book Title</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {context.connectedCourses.map((contextCourse, i) => (
            <tr key={i}>
              <td>{contextCourse.createDate}</td>
              <td>
                <a href={`/instructor/people/${contextCourse.coursenum}`}>
                  {contextCourse.coursenum}
                </a>
              </td>
              <td className="maxw-400px">
                <a href={`/instructor/setup/${contextCourse.coursenum}`}>
                  {contextCourse.courseTitle}
                </a>
              </td>
              <td>
                <a href={`/reader/web/${contextCourse.coursenum}`}>
                  {contextCourse.title}
                </a>
              </td>
              <td>
                <a
                  onClick={() => openModal(contextCourse)}
                  className="btn btn-sm btn-sm-myed btn-danger"
                >
                  Remove <i className="far fa-window-close" />
                </a>
                <a
                  onClick={() =>
                    showAssessmentTool(contextCourse.coursenum, 'assessments')
                  }
                  className="btn btn-sm btn-sm-myed btn-primary"
                >
                  Activity IDs
                </a>
                <a
                  onClick={() =>
                    showAssessmentTool(contextCourse.coursenum, 'students')
                  }
                  className="btn btn-sm btn-sm-myed btn-primary"
                >
                  Student IDs
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <RemoveCourseModal
        contextCourse={contextCourseModalObject}
        show={removeCourseModalOpen}
        toggle={toggleModal}
      />
    </Fragment>
  )
}

ContextCoursesTable.propTypes = {
  context: PropTypes.object.isRequired,
}

export default ContextCoursesTable
